import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlementAdditionalTaxesReport extends Layout {
    checkboxReverseVoids: Checkbox;
    excludabletextboxPayAdjCodes: ExcludableTextbox;
    excludabletextboxPayees: ExcludableTextbox;
    excludabletextboxState: ExcludableTextbox;
    sourceAdditionalTaxes: DataSource;
    switchReportType: Switch;
    textboxDateRange: Textbox;
    textboxReportBy: Textbox;
    textboxSecondaryGroupBy: Textbox;
    textboxTaxType: Textbox;
}
